import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { SET_CONFIGURATION_DATA } from './mutations';
import api from '@/api';
import { setWidgetData } from '../widgets/actions';
import state from './state';
import { isNullOrUndefined } from '../../../utils/helpers';
import { setAllWorkflowData, markWorkflowSetupComplete } from '../workflows/actions';
import { selectedWorkflowId } from '../selectedWorkflow/getters';

const buildWorkflowConfigurationActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const createConfiguration = buildWorkflowConfigurationActionObject('createConfiguration');
export const getConfiguration = buildWorkflowConfigurationActionObject('getConfigurationAction');
export const setConfigurationData = buildWorkflowConfigurationActionObject('setConfigurationData');
export const addInterface = buildWorkflowConfigurationActionObject('addInterface');
export const saveConfigurationsResponses = buildWorkflowConfigurationActionObject('saveConfigurationsResponses');
export const saveConfigurationFieldResponse = buildWorkflowConfigurationActionObject('saveConfigurationFieldResponse');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [createConfiguration.action]({ dispatch }, payload) {
		const { workflowId, isGeneralConfiguration } = payload;
		const ret = await api.createConfigurationForWorkflow(workflowId, isGeneralConfiguration);

		await dispatch(setAllWorkflowData.fullPath, { data: ret }, { root: true });

		return ret;
	},
	async [getConfiguration.action]({ dispatch }, payload) {
		const { id, forceGet } = payload;
		const dataIsMissing = isNullOrUndefined(state.data[id]);
		const needToGet = dataIsMissing || forceGet;
		if (needToGet) {
			const ret = await api.getConfiguration(id);
			dispatch(setConfigurationData.action, { data: ret });
		}
	},
	[setConfigurationData.action]({ commit, dispatch }, payload) {
		const { data: workflowConfiguration } = payload;
		workflowConfiguration.workflow_configuration_interfaces.forEach((workflowConfigurationInterface) => {
			dispatch(setWidgetData.fullPath, { data: workflowConfigurationInterface.interface }, { root: true });
		}); // loop over interfaces and keep them
		commit(SET_CONFIGURATION_DATA, { key: workflowConfiguration.id, value: workflowConfiguration });
	},
	async [addInterface.action]({ dispatch }, payload) {
		const { configurationId } = payload;
		const workflowConfiguration = await api.addInterfaceToConfiguration(configurationId);
		dispatch(setConfigurationData.action, { data: workflowConfiguration });
	},
	async [saveConfigurationsResponses.action]({ dispatch, rootGetters }, payload) {
		const configurationsResponses = await api.saveConfigurationsResponses(
			rootGetters[selectedWorkflowId.fullPath],
			payload.response,
			payload.applyConfigurationsResponseOnDraft
		);
		await dispatch('configurationEditor/setConfigurationsValues', {}, { root: true }); // not imported because of circular dependencies issue
		dispatch(markWorkflowSetupComplete.fullPath, { id: rootGetters[selectedWorkflowId.fullPath] }, { root: true });
		configurationsResponses.map((configurationResponse) => dispatch(setConfigurationData.action, { data: configurationResponse }));
		return configurationsResponses;
	},
	async [saveConfigurationFieldResponse.action]({ dispatch }, payload) {
		const { id, interfaceUUID, fieldUUID, response } = payload;
		const configurationResponse = await api.saveConfigurationFieldResponse(id, interfaceUUID, fieldUUID, response);
		dispatch(setConfigurationData.action, { data: configurationResponse });
		return configurationResponse;
	},
};

export default actions;
